{
  "header": {
    "title": "Profil",
    "description": "Gérez votre compte utilisateur"
  },
  "tabs": {
    "settings": {
      "label": "Paramètres",
      "saveChangeButton": "Enregistrer les modifications",
      "photoSection": {
        "title": "Photo",
        "changePhotoButton": "Changer la photo",
        "maxSize": "Max. 5 Mo",
        "format": "Format PNG, JPG"
      },
      "personalInformationSection": {
        "title": "Informations personnelles",
        "nonEditable": {
          "nameInput": { "label": "Nom" },
          "jobTitleInput": { "label": "Poste" },
          "managerNameInput": { "label": "Nom du responsable" },
          "userRoleInput": { "label": "Rôle utilisateur" },
          "emailInput": { "label": "Email" },
          "departmentInput": { "label": "Département" },
          "tenureInput": { "label": "Ancienneté" }
        },
        "editable": {
          "languageInput": { "label": "Langue" },
          "dateFormatInput": { "label": "Format de date" },
          "locationInput": { "label": "Localisation" },
          "timeZoneInput": { "label": "Fuseau horaire" }
        }
      },
      "emailPreferencesSection": {
        "weeklyDigest": "Envoyer un résumé hebdomadaire des questions récentes par e-mail",
        "monthlyDigest": "Envoyer un résumé mensuel contenant vos contributions"
      }
    },
    "directReports": {
      "label": "Mes subordonnés directs",
      "emptyState": {
        "title": "Aucun subordonné direct",
        "description": "Vous n’avez pas encore de subordonnés directs. Lorsque des personnes vous seront rattachées, elles apparaîtront ici."
      },
      "error": {
        "title": "Impossible de charger les subordonnés directs",
        "description": "Une erreur s’est produite lors du chargement de vos subordonnés directs. Veuillez réessayer.",
        "retry": "Réessayer"
      }
    }
  }
}
